import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Tree } from 'primereact/tree';


class CategorieSectionTrees extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: {
        isVisible: false,
        title: '',
        children: null,
        textOk: '',
        textHide: '',
        actionOk: null,
        actionHide: () => {},
      },
      navegationTreeList: [],
      selectedNavegationTree: '',
      selectedLabelNavegationTree: '',
    };
  }

  componentDidMount() {
    const { categoriesSectionCatalog, value, onChangeCategorie } = this.props;
    this.setState({ navegationTreeList: categoriesSectionCatalog }, () => {
      if (value) {
        this.onChangeTree({value: value})
      }
    });
  }

  componentDidUpdate (prevProps) {
    if (prevProps.categoriesSectionCatalog !== this.props.categoriesSectionCatalog) {
      this.setState({navegationTreeList: this.props.categoriesSectionCatalog})
    }

  }

  onChangeTree = (e) => {
    const { onChangeCategorie } = this.props;
    const { navegationTreeList } = this.state;
    this.setState({ selectedNavegationTree: e.value });
    const element = navegationTreeList[0];
    const findValue = this.searchTree(element, e.value);

    const fullLabel = this.getLabelComplete(findValue, findValue.label)
    this.setState({ selectedLabelNavegationTree: fullLabel });
    onChangeCategorie({value: e.value, label: fullLabel, rest: findValue})
    this.onHideModal()
  };

  searchTree = (element, matchingTitle) => {
    if (element.key === matchingTitle) {
      return element;
    }
    if (element.children != null) {
      let i;
      let result = null;
      for (i = 0; result == null && i < element.children.length; i += 1) {
        result = this.searchTree(element.children[i], matchingTitle);
      }
      return result;
    }
    return null;
  };

  getLabelComplete = (findValue, string) => {
    const { navegationTreeList } = this.state;
    let newString = string
    if (findValue.parentKey) {
      const findValueP = this.searchTree(navegationTreeList[0], findValue.parentKey);
      if (findValueP.parentKey) newString = `${findValueP.label}/${newString}`
      else newString = `${findValueP.label}/${newString}`
      return this.getLabelComplete(findValueP, newString)
    }
    return newString
  }

  filterByCategory = () => {
    const { t } = this.props
    const { navegationTreeList, selectedNavegationTree } = this.state;
    const children = (
      <div className="p-mt-2">
        <Tree
          value={navegationTreeList}
          selectionMode="single"
          selectionKeys={selectedNavegationTree}
          onSelectionChange={this.onChangeTree}
          filter
          filterMode="lenient"
        />
      </div>
    );
    this.setState({
      showModal: {
        isVisible: true,
        title: t('Árbol de navegación'),
        textOk: null,
        textHide: t('Cerrar'),
        actionOk: null,
        actionHide: () => this.onHideModal(),
        children,
      },
    });
  };

  onHideModal = () => {
    this.setState({
      showModal: {
        isVisible: false,
        actionHide: () => {},
      },
    });
  };

  render() {
    const {
      showModal,
      selectedLabelNavegationTree,
    } = this.state;
    
    const { t } = this.props

    const footerModal = (
      <div>
        {showModal.actionHide && (
          <Button label={showModal.textHide} onClick={showModal.actionHide} />
        )}
        {showModal.actionOk && (
          <Button label={showModal.textOk} onClick={showModal.actionOk} />
        )}
      </div>
    );

    return (
      <>
        <Button
          type="button"
          label={
            selectedLabelNavegationTree
              ? `${selectedLabelNavegationTree}`
              : t('Seleccione sección')
          }
          className="p-button-text"
          onClick={() => this.filterByCategory()}
        />
        <Dialog
          header={showModal.title}
          visible={showModal.isVisible}
          breakpoints={{'960px': '90vw'}}
          style={{ width: '35vw' }}
          footer={footerModal}
          onHide={showModal.actionHide}
        >
          {showModal.children}
        </Dialog>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  categoriesSectionCatalog: state.catalogs.sectionTreeCurrentCatalog,
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, null)
  )(CategorieSectionTrees);
